/* __next_internal_client_entry_do_not_use__ TestimonialTabItem,Default auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
// Global
import { useRef } from 'react';
import { tv } from 'tailwind-variants';
import { withStandardComponentWrapper } from 'helpers/HOC';
import { getTestProps } from 'lib/testing/utils';
import { PlaceholderWrapper } from 'helpers/SitecoreWrappers/PlaceholderWrapper/PlaceholderWrapper';
import { useTab } from 'helpers/Context/TabContext';
import { EditingHelpText } from 'helpers/Editing/EditingHelpText';
import useDictionary from 'lib/hooks/useDictionary';
import useIsEditing from 'lib/hooks/useIsEditing';
import { editingHydrationProps } from 'lib/hooks/useEditingHydrationProps';
const TestimonialTabItem = (props)=>{
    const { DynamicPlaceholderId } = props?.params || {};
    const { uid } = props?.rendering || {};
    const { getDictionaryValue } = useDictionary();
    const TabId = `tab-content-${uid}`;
    const tabItemHeadlineRef = useRef(null);
    const { activeTab, tabs } = useTab();
    const isActive = props?.rendering?.uid === activeTab;
    const isEditing = useIsEditing();
    const hasMultipleItems = tabs.length > 1;
    const shouldShowTabs = hasMultipleItems || isEditing;
    const { base } = TAILWIND_VARIANTS({
        isActive
    });
    const phKey = `testimonialcard-${DynamicPlaceholderId}`;
    return (
        /*#__PURE__*/ _createElement("div", {
            "data-component": "authorable/shared/lists/TestimonialTabItem",
            ...editingHydrationProps(isEditing),
            className: base({
                isActive
            }),
            key: TabId,
            ref: tabItemHeadlineRef,
            id: TabId,
            role: "tabpanel",
            "aria-live": "polite",
            ...(shouldShowTabs && {
                'aria-labelledby': `tab-${uid}`
            }),
            ...getTestProps(`component-tab-item-${TabId}`),
            children: [
                /*#__PURE__*/ _jsxs(EditingHelpText, {
                    children: [
                        "\uD83D\uDCA1 ",
                        /*#__PURE__*/ _jsxs("strong", {
                            children: [
                                getDictionaryValue('Tip') || 'Tip',
                                ":"
                            ]
                        }),
                        ' ',
                        getDictionaryValue('TestimonialTabItemHelpText') || 'Drag another Testimonial Tab Item above or below this one to add more testimonials to the carousel'
                    ]
                }),
                /*#__PURE__*/ _jsx(PlaceholderWrapper, {
                    name: phKey,
                    rendering: props.rendering,
                    ...getTestProps(`testimonialcard-ph-${props?.rendering?.uid}`)
                })
            ]
        })
    );
};
export { TestimonialTabItem };
export const Default = withStandardComponentWrapper(TestimonialTabItem);
const TAILWIND_VARIANTS = tv({
    slots: {
        base: [
            'flex',
            'flex-col',
            'gap-spacing-spacing-24'
        ]
    },
    variants: {
        isActive: {
            true: {
                base: [
                    'visible'
                ]
            },
            false: {
                base: [
                    'hidden'
                ]
            }
        }
    }
});
